'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = modal;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    is_show: false,
    title: '',
    content: null,
    titleSuccess: 'OK',
    titleClose: 'Отмена',
    onSuccess: function onSuccess() {},
    modalType: null,
    timerId: null
};

function modal() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.ModalConstants.MODAL_SHOW:
            return (0, _extends3.default)({}, state, action.state, {
                is_show: true
            });
        case _constants.ModalConstants.MODAL_HIDE:
            if (state.timerId) {
                clearTimeout(state.timerId);
            }

            return (0, _extends3.default)({}, state, {
                timerId: null,
                is_show: false
            });
        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/modal.js
// module id = 1904
// module chunks = 0